/** Where the phone is, for a clock-in. Never blocks: refused or unavailable comes back as a status, and the clock-in goes ahead and is flagged. */
export function currentLocation(timeoutMs = 10000) {
  return new Promise((resolve) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) { resolve({ location_status: "UNAVAILABLE" }); return; }
    let done = false;
    const finish = (v) => { if (!done) { done = true; resolve(v); } };
    const timer = setTimeout(() => finish({ location_status: "UNAVAILABLE" }), timeoutMs + 1000);
    navigator.geolocation.getCurrentPosition(
      (p) => { clearTimeout(timer); finish({ latitude: p.coords.latitude, longitude: p.coords.longitude, accuracy_m: Math.round(p.coords.accuracy || 0), location_status: "OK" }); },
      (err) => { clearTimeout(timer); finish({ location_status: err && err.code === 1 ? "DENIED" : "UNAVAILABLE" }); },
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 60000 },
    );
  });
}

export const mapLink = (lat, lng) => `https://www.google.com/maps?q=${lat},${lng}`;
